import MainTitle from '../../components/MainTitle'
import { NavLink } from 'react-router-dom'
import CardButton from '../../components/CardButton'
import useAuth from '../../hooks/useAuth'

import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faTrashCan,
  faMagnifyingGlass,
  faEye,
  faPlus,
  faSort,
  faSortUp,
  faSortDown,
  faAngleDoubleLeft,
  faChevronLeft,
  faChevronRight,
  faAngleDoubleRight,
} from '@fortawesome/free-solid-svg-icons'
import Modal from '../../components/Modal'
import { Link } from 'react-router-dom'
import moment from 'moment'

function Schools() {

  const axios = useAxiosPrivate()
  const { setShowLoader, showLoader, can, createInfo } = useAuth()

  const [schools, setSchools] = useState([])
  const [deleteschool, setDeleteSchool] = useState({})
  const [showModal, setShowModal] = useState(false)

  const [search, setSearch] = useState('')

  const [currentRecords, setCurrentRecords] = useState([])
  const [filteredRecords, setFilteredRecords] = useState([])
  const [nPages, setNumberOfPages] = useState(0)

  const [currentPage, setCurrentPage] = useState(1)
  // No of Records to be displayed on each page
  const [recordsPerPage] = useState(10)

  const [indexOfLastRecord, setIndexOfLastRecord] = useState(10)
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0)

  const [modalTitle, setModalTitle] = useState('')

  const [isMissedReservationWindow, setIsMissedReservationWindow] = useState(false)
  const [originalRecords, setOriginalRecords] = useState([])
  const [columnClickCounts, setColumnClickCounts] = useState({})
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  })

  const [debounceTimer, setDebounceTimer] = useState(null);
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc', 'desc', or null
  const [itemsPerPage, setItemsPerPage] = useState(0)
  const [totalItems, setTotalItems] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [fromItem, setFromItem] = useState(0)
  const [toItem, setToItem] = useState(0)
  const [loaded, setLoaded] = useState(false)

  const [totalSchools, setTotalSchools] = useState(0)

  useEffect(() => {
  if (debounceTimer) clearTimeout(debounceTimer);

  const timer = setTimeout(() => {
    getSchools();
  }, 1500);

  setDebounceTimer(timer);

  return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    getSchools();
  }, [sortField, sortDirection, currentPage]); 

  const getSchools = async () => {
    if(!loaded) {
      setShowLoader(true);
      try {
        const response = await axios.post('/schools/all', {
          searchTerm: search,
          sortField: sortField,
          sortDirection: sortDirection,
          perPage: recordsPerPage,
          page: currentPage,
        });

        const filteredSchools = response.data.result.data;
        if (response.data.result.pagination) {
          const pagination = response.data.result.pagination
          setTotalItems(pagination.total)
          setTotalPages(pagination.last_page)
          setItemsPerPage(pagination.per_page)
          setFromItem(pagination.from || 0)
          setToItem(pagination.to || 0)
        }
        setTotalSchools(response.data.result.total);
        setSchools(filteredSchools);
        setOriginalRecords(filteredSchools);
        setFilteredRecords(filteredSchools);
        setCurrentRecords(filteredSchools.slice(indexOfFirstRecord, indexOfLastRecord));
        setNumberOfPages(Math.ceil(filteredSchools.length / recordsPerPage));
        setLoaded(true)
      } catch (error) {
        console.error(error);
      }

      setShowLoader(false);
    }

  };

  const resetFilters = () => {
    setSearch('');
    setIsMissedReservationWindow(false);
  };

  const ModalBody = () => {
    if (deleteschool.id) {
      return <DischargeschoolElement />
    }
  }

  const resetModal = (resetschools = true) => {
    setDeleteSchool({})
    setShowModal(false)
    if (resetschools) {
      setSchools(schools)
    }
  }

  const DischargeschoolElement = () => {
    const [sendDischargeEmail, setSendDischargeEmail] = useState(false)
    const handleCheckboxChange = (e) => {
      setSendDischargeEmail(e.target.checked)
    }

    const deleteschoolFn = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      resetModal(false)
      try {
        const response = await axios.post(`/schools/${deleteschool.id}/update-status`, {
          sendDischargeEmail: sendDischargeEmail,
        })

        if (response.status === 200) {
          createInfo('success', `school status updated successfully`);
          setCurrentRecords((prev) =>
            prev.map((item) =>
              item.id === deleteschool.id
                ? { ...item, title: 'Discharged Pre-assessment' }
                : item
            )
          );
        }
      } catch (error) {
        createInfo('error', 'Failed to update school status');
        console.error(error);
      }
      setShowLoader(false)
    }

    const deleteSchoolClicked = (school) => {
      setDeleteSchool(school)
      setModalTitle(`Delete school: ${school.name}`)
      setShowModal(true)
    }

    return (
      <form onSubmit={deleteschoolFn}>
        <div className="mb-3">
          <p className="text-lg font-bold mt-8 mb-4 text-center">
            You are discharging school {deleteschool.name}
          </p>
          <p className="text-center mt-6">
            Would you like to send a confirmation discharge email?
          </p>
          <div className="flex items-center ps-4 mb-4 mt-2 border border-gray-200 rounded dark:border-gray-700">
            <input
              id="bordered-checkbox-1"
              type="checkbox"
              value=""
              name="bordered-checkbox"
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              checked={sendDischargeEmail}
              onChange={handleCheckboxChange}
            />
            <label
              htmlFor="bordered-checkbox-1"
              className="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Yes, send discharge confirmation
            </label>
          </div>

          <div className="flex w-full mt-8">
            <button className="btn red mt-4 mr-4 w-1/2">Discharge school</button>

            <button
              type="button"
              className="btn mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }
  
  const handleSort = (key) => {
    let clicks = { ...columnClickCounts };

    if (!clicks[key]) clicks[key] = 1;
    else clicks[key]++;

    let nextDirection = 'asc'; // default = reset

    if (clicks[key] >= 3) {
      clicks[key] = 0; // reset cycle
      setSortField('name')   
    } else {
      if (clicks[key] === 2) {
        nextDirection = 'desc';
      }
      setSortField(key)
    }

    setColumnClickCounts(clicks);
    setSortDirection(nextDirection);
  };

  const renderSortArrow = (columnKey) => {
    if (sortConfig.key === columnKey) {
      if (sortConfig.direction === 'ascending') {
        return <FontAwesomeIcon icon={faSortUp} />
      } else {
        return <FontAwesomeIcon icon={faSortDown} />
      }
    }
    return <FontAwesomeIcon icon={faSort} />
  }

  const deleteSchoolClicked = (school) => {
    setDeleteSchool(school)
    setModalTitle(`Delete school: ${school.name}`)
    setShowModal(true)
  }

  return (
    <section>
      <MainTitle title="Schools" />

      <section>
        {showModal && (
          <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
        )}
        <ul className="flex flex-col md:flex-row just-between flex-wrap">
          {can('create clients') && (
            <li className="w-full md:w-1/4 mb-6 mr-3">
              <NavLink to="new">
                <CardButton icon={faPlus} title="Create New School" />
              </NavLink>
            </li>
          )}
          <li className="rounded-md bg-white shadow h-20 w-full md:w-1/4 px-4 mb-6 flex flex-col justify-center mr-3">
            <h2 className="font-bold">Total Schools</h2>
            <p className="text-3xl font-black">{totalSchools}</p>
          </li>
        </ul>
      </section>

      <div className='flex flex-col md:flex-row justify-between '>
        <div className="py-4">
          <div className="relative mt-1">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </div>
            <input
              type="text"
              id="table-search"
              value={search}
              onChange={searchEvent => setSearch(searchEvent.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search schools"
            />
          </div>
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        <table className="table-main">
          <thead>
            <tr>
              <th
                className="cursor-pointer"
                scope="col"
                onClick={() => handleSort('id')}
              >
                ID {renderSortArrow('id')}
              </th>
              <th
                className="cursor-pointer"
                scope="col"
                onClick={() => handleSort('name')}
              >
                School Name {renderSortArrow('name')}
              </th>
              {/* CHANGE SORT AND ARROW */}
              <th
                className="cursor-pointer"
                scope="col"
                onClick={() => handleSort('school_contact_name')}
              >
                Contact Name {renderSortArrow('school_contact_name')}
              </th>
              {/* CHANGE SORT AND ARROW */}
              <th
                className="cursor-pointer"
                scope="col"
                onClick={() => handleSort('email')}
              >
                Contact Email {renderSortArrow('email')}
              </th>
              <th
                className="cursor-pointer"
                scope="col"
                onClick={() => handleSort('created_at')}
              >
                Created At {renderSortArrow('created_at')}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="table-main">
            {currentRecords.length > 0 ? (
              currentRecords.map((school) => {
                return (
                  <tr key={school.id}>
                    <td>{school.id}</td>
                    <td>{school.name}</td>
                    <td>{school.client_details?.school_contact_name}</td>
                    <td>{school.email}</td>
                    <td>{moment(school.created_at).format('DD/MM/YYYY')}</td>
                    <td>
                      <div className="flex justify-center space-x-2">
                        <Link to={`/schools/${school.id}`}>
                          <span className="flex justify-center items-center bg-blue-400 rounded-md text-blue-800 h-9 w-12 hover:bg-blue-500 cursor-pointer">
                            <FontAwesomeIcon icon={faEye} />
                          </span>
                        </Link>
                        {isMissedReservationWindow && (
                          <span
                            onClick={() => deleteSchoolClicked(school)}
                            className="flex justify-center items-center bg-red-400 rounded-md text-red-800 h-9 w-12 hover:bg-red-500 cursor-pointer"
                          >
                            <FontAwesomeIcon icon={faTrashCan} />
                          </span>
                        )}
                      </div>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={8}>
                  <p className="no-records">No schools found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center mt-4">
          <p>
            {totalItems > 0 ? (
              `Showing ${fromItem} to ${toItem} of ${totalItems} results`
            ) : (
              'No results found'
            )}
          </p>
          <div className="flex">
            <button
              className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </button>
            <button
              className="relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
              Previous
            </button>
            <button
              className="relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
              <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
            </button>
            <button
              className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
            >
              <FontAwesomeIcon icon={faAngleDoubleRight} />
            </button>
          </div>
        </div>
    </section>
  )
}

export default Schools